/*
 *
 * TechnicalErrorModal
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 07-Nov-2024
*/

import { connect } from 'react-redux'
import { doHidePopup } from 'Store/actions/popup'
import TechnicalErrorModal from './TechnicalErrorModal'

const mapDispatchToProps = dispatch => ({
  doHidePopup: () => dispatch(doHidePopup())
})

const mapStateToProps = () => ({

})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(TechnicalErrorModal)
